module.exports = __webpack_public_path__ + "images/155_4096.jpg";